import type { TFunction } from 'i18next';
import { Fragment } from 'react';
import { STATUS_MARKS } from '../../utils/statusTonePalette.ts';
import { getWidgetNotices } from '../../utils/widgetNotices.ts';
import {
  getTargetingChipTone,
  parseTargetingChipsPayload,
  type TargetingChipItem,
} from '../utils/targetingChipsPayload.ts';

type OpenXAgentTargetingCopyChipsProps = {
  payload: unknown;
  t: TFunction;
};

const chipText = ({ label, value, status }: TargetingChipItem) =>
  `${STATUS_MARKS[getTargetingChipTone(status)]} ${value === null ? label : `${label}: ${value}`}`;

export const OpenXAgentTargetingCopyChips = ({ payload, t }: OpenXAgentTargetingCopyChipsProps) => {
  const parsed = parseTargetingChipsPayload(payload);
  if (!parsed.ok) return <p>{getWidgetNotices(t).errorNotice}</p>;

  return (
    <div>
      {parsed.value.groups.map(group => (
        <p key={group.id}>
          <strong>{group.label}</strong>
          {group.items.map(item => (
            <Fragment key={item.id}>
              <br />
              {chipText(item)}
            </Fragment>
          ))}
        </p>
      ))}
    </div>
  );
};
